import React, { useEffect, useRef } from 'react';
import { StyledArticlesHead } from './StyledArticlesHead';
import { useLocation,useHistory } from 'react-router-dom';
import gsap from 'gsap';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ArticlesHead = ({ topArticles }) => {

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const imageCover = useRef(null);
  const triggerHover = (event,isHover) => {
    if(!('ontouchstart' in window)){
      var followMouseEl =  event.currentTarget.querySelector('.news-follow-cursor')
      var TL = gsap.timeline()
      gsap.to('.cursor', {opacity: isHover ? 0 : 1, duration: 0.5})
      
      TL.to(followMouseEl, {autoAlpha: isHover ? 1 : 0 })
    }
   
  }
  const handleCLick = (slug) => {
    
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }

  useEffect(() => {
    gsap.to(imageCover.current, {
      scale: '1.1',
      ease: "none",
      scrollTrigger: {
        trigger: imageCover.current,
        start: "top bottom", 
        end: "+=20%",
        scrub: false
      }
    });
  },[])
 
  return (
    <React.Fragment>
      {
       
          <StyledArticlesHead>
            <svg id="svgfilters" aria-hidden="true" style={{position: "absolute", width: 0, height: 0, overflow: "hidden"}} >
            <defs>
              <filter id="green-filter" x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feColorMatrix type="matrix" values=".33 .33 .33 0 0
                  .33 .33 .33 0 0
                  .33 .33 .33 0 0
                  0 0 0 1 0" in="SourceGraphic" result="colormatrix"/>
                <feComponentTransfer in="colormatrix" result="componentTransfer">
                  <feFuncR type="table" tableValues="0.27 1"/>
                  <feFuncG type="table" tableValues="0.72 1"/>
                  <feFuncB type="table" tableValues="0.40 1"/>
                  <feFuncA type="table" tableValues="0 1"/>
                </feComponentTransfer>
                <feBlend mode="normal" in="componentTransfer" in2="SourceGraphic" result="blend"/>
              </filter>
            </defs>
            </svg>
            <h4 className="md--title main-title">Check out latest and greatest from our newsroom</h4>
            <div className="articles-top--wrap">
              <div className="article--big">
                <p className="preset-13 category" onClick={() => handleCLick(`/news/category/${topArticles[0].category.toLowerCase().replace(' ', '-')}`)} >{topArticles[0].category}</p>
                <h5 className="big--title title-article" onClick={() => handleCLick(`/news/${topArticles[0].slug}`)}>{topArticles[0].title}</h5>
                <div className="details-wrapper">
                  <div className="detail-col">
                    <img src="/calendar-date.svg" />
                    <p className="preset-12">{topArticles[0].date}</p>
                  </div>
                  <div className="detail-col">
                    <img src="/time.svg" />
                    <p className="preset-12">{topArticles[0].reading_time} min read</p>
                  </div>
                </div>
                <div className="cover-wrap">
                  <img ref={imageCover} className="cover" src={topArticles[0].tumb} />
                </div>
              </div>
              <div className="articles--col">
                <div 
                  className="article--cell"
                  onMouseEnter={(e) => triggerHover(e,true)}
                  onMouseLeave={(e) => triggerHover(e,false)}
                >
                  <p className="preset-13 category" onClick={() => handleCLick(`/news/category/${topArticles[1].category.toLowerCase().replace(' ', '-')}`)}>{topArticles[1].category}</p>
                  <p className="preset-9 title-article" onClick={() => handleCLick(`/news/${topArticles[1].slug}`)}>{topArticles[1].title}</p>
                  <div className="news-follow-cursor" style={{backgroundImage: `url(${topArticles[1].tumb})`}}>
                  </div>
                  <div className="details-wrapper">
                    <div className="detail-col">
                      <img src="/calendar-date.svg" />
                      <p className="preset-12">{topArticles[1].date}</p>
                    </div>
                    <div className="detail-col">
                      <img src="/time.svg" />
                      <p className="preset-12">{topArticles[1].reading_time} min read</p>
                    </div>
                  </div>
                </div>
                <div 
                  className="article--cell"
                  onMouseEnter={(e) => triggerHover(e,true)}
                  onMouseLeave={(e) => triggerHover(e,false)}
                >
                  <p className="preset-13 category" onClick={() => handleCLick(`/news/category/${topArticles[2].category.toLowerCase().replace(' ', '-')}`)}>{topArticles[2].category}</p>
                  <p className="preset-9 title-article" onClick={() => handleCLick(`/news/${topArticles[2].slug}`)}>{topArticles[2].title}</p>
                  <div className="news-follow-cursor" style={{backgroundImage: `url(${topArticles[2].tumb})`}}>
                    
                  </div>
                  <div className="details-wrapper">
                    <div className="detail-col">
                      <img src="/calendar-date.svg" />
                      <p className="preset-12">{topArticles[2].date}</p>
                    </div>
                    <div className="detail-col">
                      <img src="/time.svg" />
                      <p className="preset-12">{topArticles[2].reading_time} min read</p>
                    </div>
                  </div>
                </div>
                <div 
                  className="article--cell"
                  onMouseEnter={(e) => triggerHover(e,true)}
                  onMouseLeave={(e) => triggerHover(e,false)}
                >
                  <p className="preset-13 category" onClick={() => handleCLick(`/news/category/${topArticles[3].category.toLowerCase().replace(' ', '-')}`)}>{topArticles[3].category}</p>
                  <p className="preset-9 title-article" onClick={() => handleCLick(`/news/${topArticles[3].slug}`)}>{topArticles[3].title}</p>
                  <div className="news-follow-cursor" style={{backgroundImage: `url(${topArticles[3].tumb})`}}>
                    
                  </div>
                  <div className="details-wrapper">
                    <div className="detail-col">
                      <img src="/calendar-date.svg" />
                      <p className="preset-12">{topArticles[3].date}</p>
                    </div>
                    <div className="detail-col">
                      <img src="/time.svg" />
                      <p className="preset-12">{topArticles[3].reading_time} min read</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </StyledArticlesHead>
          
      }
    </React.Fragment>
  );
};

export default ArticlesHead;
